/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_TeamInputs */

const en_entity_team = /** @type {(inputs: Entity_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

const de_entity_team = /** @type {(inputs: Entity_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "Team" |
*
* @param {Entity_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_team = /** @type {((inputs?: Entity_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_team(inputs)
	return de_entity_team(inputs)
});